import type {LvsColorKey} from '../lvs-colors'
import type {BgColor} from './layout'

export interface SignColors {
    readonly bg: LvsColorKey
    readonly edge: LvsColorKey
    readonly border: LvsColorKey
    readonly text: LvsColorKey
}

/**
 * Resolve the four logical sign roles (background, black-edge,
 * contrast-border, text) to concrete LVS palette keys for the given
 * `BgColor`. Single source of truth across screen and print render paths.
 */
export function resolveSignColors(bg: BgColor): SignColors {
    return {
        bg: bg === 'white' ? 'white' : 'blue',
        edge: 'black',
        border: 'white',
        text: bg === 'white' ? 'black' : 'white'
    }
}
